/* REVON theme. Navigation, hero, variant selection on the product page, the
   Legacy Set configurator, and a cart driven by Shopify's Cart AJAX API. No
   prices are computed here: every total comes back from /cart.js so the drawer
   can never disagree with checkout. */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* The catalogue spells it Gray, the photo alt text says grey. Fold the two
     together so a colour never fails to match its own pictures. */
  var norm = function (s) { return String(s == null ? '' : s).toLowerCase().replace(/grey/g, 'gray'); };
  var same = function (a, b) { return norm(a) === norm(b); };

  /* Shared add-to-cart. Shopify answers 422 with a reason when a line cannot
     be added; surfacing that beats opening an empty cart. */
  function addToCart(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.description || body.message || 'That could not be added to the cart.');
        return body;
      });
    }).then(function () { return refresh(); })
      .then(function () { openBag(); });
  }

  function say(el, message) {
    if (!el) return;
    el.hidden = !message;
    if (message) el.textContent = message;
  }

  /* ---------------- navigation ---------------- */
  function nav() {
    var bar = qs('.nav');
    if (bar) {
      var onScroll = function () { bar.classList.toggle('stuck', window.scrollY > 8); };
      addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var burger = qs('[data-burger]'), sheet = qs('.sheet');
    if (!burger || !sheet) return;
    var setOpen = function (open) {
      document.body.classList.toggle('menu-open', open);
      document.body.classList.toggle('is-locked', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    };
    burger.onclick = function () { setOpen(!document.body.classList.contains('menu-open')); };
    qsa('a', sheet).forEach(function (a) { a.onclick = function () { setOpen(false); }; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------------- hero ---------------- */
  /* Four plates, one rail. Deliberately no auto rotation: the visitor chooses
     whether to see the back print or the grey colourway. */
  function hero() {
    var figs = qsa('.hero__fig'), rail = qs('[data-rail]');
    if (!figs.length || !rail) return;

    var show = function (i) {
      var f = figs[i];
      if (f && f.dataset.src) { f.src = f.dataset.src; delete f.dataset.src; }
      figs.forEach(function (f, n) { f.classList.toggle('on', n === i); });
      qsa('button', rail).forEach(function (b, n) {
        b.classList.toggle('on', n === i);
        b.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    };

    rail.innerHTML = figs.map(function (f, i) {
      return '<button type="button" role="tab" data-go="' + i + '" aria-label="' +
        (f.getAttribute('alt') || 'Look ' + (i + 1)).replace(/"/g, '&quot;') + '"></button>';
    }).join('');
    qsa('[data-go]', rail).forEach(function (b) {
      b.onclick = function () { show(parseInt(b.dataset.go, 10)); };
    });
    show(0);
  }

  /* ---------------- product ---------------- */
  /* Options are whatever the product actually carries. The two single
     garments have a colour and a size; the Legacy Set has a size and a colour
     for each piece. Nothing here assumes option one is a colour. */
  function product() {
    var root = qs('[data-product]');
    if (!root) return;
    var data = qs('[data-variants]', root);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    if (!variants.length) return;

    var colorOpts = (root.dataset.coloropts || '').split(',')
      .filter(function (x) { return x !== ''; }).map(Number);
    var galOpt = parseInt(root.dataset.galopt, 10);
    var count = variants[0].o.length;
    var plainOpts = [];
    for (var k = 0; k < count; k++) if (colorOpts.indexOf(k) === -1) plainOpts.push(k);

    var group = qs('[data-pick-group]', root);
    var partners = [];
    if (group) {
      var pj = qs('[data-partner-variants]', group);
      if (pj) partners = JSON.parse(pj.textContent);
    }

    var state = { o: new Array(count).fill(null), pcolor: null, qty: 1, bundle: false };

    /* Colours open on something in stock; sizes stay unchosen so the shopper
       has to pick one. A ?variant= link overrides both, which is how the
       colourways row lands on the colour it advertised. */
    /* The opening colourway is chosen in Liquid so the server can eagerly load
       the one photograph that will actually be shown. This scoring is the same
       rule, kept as a fallback for markup rendered without it. */
    var key = function (v) { return colorOpts.map(function (i) { return norm(v.o[i]); }).join('|'); };
    var tally = {};
    variants.forEach(function (v) { if (v.available) tally[key(v)] = (tally[key(v)] || 0) + 1; });
    var matched = function (v) {
      return colorOpts.every(function (i) { return same(v.o[i], v.o[colorOpts[0]]); });
    };
    var firstAvail = null, bestN = -1;
    variants.forEach(function (v) {
      if (!v.available) return;
      var n = tally[key(v)];
      if (n > bestN || (n === bestN && matched(v) && !matched(firstAvail))) { bestN = n; firstAvail = v; }
    });
    firstAvail = firstAvail || variants[0];
    colorOpts.forEach(function (i) { state.o[i] = firstAvail.o[i]; });
    if (root.dataset.initial) {
      root.dataset.initial.split('~~').forEach(function (v, i) {
        if (v !== '' && i < count) state.o[i] = v;
      });
    }

    function fits(v, ignore) {
      for (var i = 0; i < count; i++) {
        if (i === ignore) continue;
        if (state.o[i] != null && !same(v.o[i], state.o[i])) return false;
      }
      return true;
    }
    function match() {
      /* Prefer something in stock. Taking the first match regardless meant
         that with no size chosen yet, a sold-out M made the whole colourway
         look dead and the rescue below moved the shopper off the colour they
         had just clicked. */
      var all = variants.filter(function (v) { return fits(v, -1); });
      return all.filter(function (v) { return v.available; })[0] || all[0];
    }
    /* A colour is offered whenever it exists in stock at all; a size is
       offered only in the colours currently chosen. */
    function canPick(i, value) {
      var colorPick = colorOpts.indexOf(i) !== -1;
      return variants.some(function (v) {
        if (!v.available || !same(v.o[i], value)) return false;
        if (colorPick) return true;
        return colorOpts.every(function (c) {
          return state.o[c] == null || same(v.o[c], state.o[c]);
        });
      });
    }
    var missing = function () {
      return plainOpts.filter(function (i) { return state.o[i] == null; })[0];
    };

    function partnerOptions() {
      var size = state.o[plainOpts[0]];
      return partners.filter(function (v) { return v.available && (!size || v.size === size); });
    }
    function partnerFor() {
      var list = partnerOptions();
      return list.filter(function (v) { return same(v.color, state.pcolor); })[0] || list[0];
    }

    /* ---- gallery, filtered by colour ---- */
    var stage = qs('[data-stage]', root);
    var ims = qsa('.gal__im', root), thumbs = qsa('.gal__t', root), dots = qsa('.gal__dots span', root);
    var view = ims.map(function (_, k) { return k; }), at = 0;

    /* An image carries one tag per colour option it names — "0:Gray|1:Black".
       It belongs in the view when every tag it carries agrees with what is
       currently selected, so a shorts-only shot follows the shorts swatch
       whatever the tee is doing. Images carrying no tag at all are the old
       client uploads; they are dropped whenever properly tagged shots exist,
       which is what stopped black pieces appearing under Gray. */
    var tagsOf = function (im) {
      return (im.dataset.ct || '').split('|').filter(Boolean).map(function (pair) {
        var bits = pair.split(':');
        return { i: parseInt(bits[0], 10), v: bits.slice(1).join(':') };
      });
    };
    var anyTagged = ims.some(function (im) { return tagsOf(im).length > 0; });

    function viewFor() {
      var keep = ims.map(function (im, k) { return { k: k, t: tagsOf(im) }; })
        .filter(function (x) {
          if (!x.t.length) return !anyTagged;
          return x.t.every(function (tag) {
            return state.o[tag.i] == null || same(state.o[tag.i], tag.v);
          });
        })
        .map(function (x) { return x.k; });
      return keep.length ? keep : ims.map(function (_, k) { return k; });
    }

    /* Stage photos past the opening one ship without a src. */
    function wake(k) {
      var im = ims[k];
      if (!im || !im.dataset.src) return;
      /* Drop lazy first: an image we are about to show must not be left to the
         browser's viewport heuristic, which can sit on it indefinitely. */
      im.loading = 'eager';
      if (im.dataset.srcset) im.srcset = im.dataset.srcset;
      im.src = im.dataset.src;
      delete im.dataset.src;
      delete im.dataset.srcset;
    }

    function show(n) {
      if (!view.length) return;
      at = (n + view.length) % view.length;
      var live = view[at];
      wake(live);
      wake(view[(at + 1) % view.length]);
      wake(view[(at - 1 + view.length) % view.length]);
      ims.forEach(function (im, k) { im.classList.toggle('on', k === live); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('on', k === live);
        t.setAttribute('aria-selected', k === live ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === at); });
    }

    function reframe() {
      view = viewFor();
      ims.forEach(function (im, k) { im.hidden = view.indexOf(k) === -1; });
      thumbs.forEach(function (t, k) { t.hidden = view.indexOf(k) === -1; });
      dots.forEach(function (d, k) { d.hidden = k >= view.length; });
      show(0);
    }

    if (stage) {
      thumbs.forEach(function (t) {
        t.onclick = function () {
          var i = view.indexOf(parseInt(t.dataset.i, 10));
          if (i !== -1) show(i);
        };
      });
      qsa('[data-step]', root).forEach(function (a) {
        a.onclick = function (e) { e.stopPropagation(); show(at + parseInt(a.dataset.step, 10)); };
      });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    /* ---- paint ---- */
    function paint() {
      qsa('[data-optgroup]', root).forEach(function (g) {
        var i = parseInt(g.dataset.optgroup, 10);
        qsa('[data-opt]', g).forEach(function (b) {
          var ok = canPick(i, b.dataset.v);
          b.disabled = !ok;
          b.classList.toggle('gone', !ok);
          b.classList.toggle('on', state.o[i] != null && same(b.dataset.v, state.o[i]));
        });
        var label = qs('[data-optvalue]', g);
        if (label) label.textContent = state.o[i] || '';

        var note = qs('[data-gone]', g);
        if (note) {
          var out = qsa('[data-opt]', g).filter(function (b) { return b.disabled; })
            .map(function (b) { return b.dataset.v; });
          var where = colorOpts.map(function (c) { return state.o[c]; }).filter(Boolean).join(' / ');
          note.hidden = out.length === 0;
          note.textContent = out.join(' and ') + ' sold out' + (where ? ' in ' + where : '');
        }
      });

      var v = match();
      var price = qs('[data-price]', root);
      if (price && v) {
        /* The repaint used to drop the struck-through was-price, which on the
           Legacy Set is the whole point of the page. */
        price.textContent = '';
        if (v.wasText) {
          var was = document.createElement('s');
          was.textContent = v.wasText;
          price.appendChild(was);
          price.appendChild(document.createTextNode(' '));
        }
        price.appendChild(document.createTextNode(v.priceText));
      }
      var qn = qs('[data-qn]', root);
      if (qn) qn.textContent = state.bundle ? 1 : state.qty;

      if (group) {
        var size = state.o[plainOpts[0]];
        var opts = partnerOptions();
        var setBtn = qs('[data-pick="set"]', group);
        if (!opts.length) {
          state.bundle = false;
          if (setBtn) { setBtn.disabled = true; setBtn.classList.remove('on'); }
          qs('[data-pick="one"]', group).classList.add('on');
        } else if (setBtn) {
          setBtn.disabled = false;
        }

        /* Keep the partner colour on something that can actually ship. */
        if (opts.length && !opts.filter(function (x) { return same(x.color, state.pcolor); }).length) {
          var mine = state.o[galOpt];
          var mirror = opts.filter(function (x) { return same(x.color, mine); })[0];
          state.pcolor = (mirror || opts[0]).color;
        }

        var extra = qs('[data-pick-extra]', group);
        if (extra) {
          extra.hidden = !state.bundle;
          qsa('[data-partner-color]', extra).forEach(function (b) {
            var can = opts.filter(function (x) { return same(x.color, b.dataset.partnerColor); }).length > 0;
            b.disabled = !can;
            b.classList.toggle('gone', !can);
            b.classList.toggle('on', same(b.dataset.partnerColor, state.pcolor));
          });
          var pn = qs('[data-partner-colorname]', extra);
          if (pn) pn.textContent = state.pcolor || '';
        }

        say(qs('[data-partner-hint]', group), size && !opts.length
          ? 'The set is not available in ' + size + '. Add this on its own, or pick another size.'
          : '');
      }

      var meta = qs('[data-sticky-meta]');
      if (meta && v) {
        var chosen = state.o.filter(Boolean).join(' / ');
        meta.textContent = (chosen ? chosen + ' · ' : '') +
          (state.bundle && group ? group.dataset.bundlePrice : v.priceText);
      }
    }

    /* ---- controls ---- */
    qsa('[data-opt]', root).forEach(function (b) {
      b.onclick = function () {
        if (b.disabled) return;
        var i = parseInt(b.dataset.opt, 10);
        state.o[i] = b.dataset.v;
        var v = match();
        if (!v || !v.available) {
          /* Drop the size rather than leave the shopper on a dead combination,
             and if the colours themselves clash, move to a pairing that ships. */
          plainOpts.forEach(function (p) { if (p !== i) state.o[p] = null; });
          if (!match() || !match().available) {
            var rescue = variants.filter(function (x) { return x.available && same(x.o[i], b.dataset.v); })[0];
            if (rescue) colorOpts.forEach(function (c) { if (c !== i) state.o[c] = rescue.o[c]; });
          }
        }
        say(qs('[data-hint]', root), '');
        reframe();
        paint();
      };
    });
    qsa('[data-q]', root).forEach(function (b) {
      b.onclick = function () {
        state.qty = Math.min(10, Math.max(1, state.qty + parseInt(b.dataset.q, 10)));
        paint();
      };
    });

    if (group) {
      qsa('[data-pick]', group).forEach(function (b) {
        b.onclick = function () {
          if (b.disabled) return;
          state.bundle = b.dataset.pick === 'set';
          if (state.bundle) state.qty = 1;
          qsa('[data-pick]', group).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          paint();
        };
      });
      qsa('[data-partner-color]', group).forEach(function (b) {
        b.onclick = function () {
          if (b.disabled) return;
          state.pcolor = b.dataset.partnerColor;
          paint();
        };
      });
    }

    function doAdd(btn) {
      var hint = qs('[data-hint]', root);
      var gap = missing();
      if (gap !== undefined) {
        var g = qs('[data-optgroup="' + gap + '"]', root);
        say(hint, 'Pick a ' + (g ? g.dataset.optname.toLowerCase() : 'size') + ' to continue');
        if (g) g.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var v = match();
      if (!v || !v.available) { say(hint, 'That combination is sold out.'); return; }

      var items = [{ id: v.id, quantity: state.qty }];
      if (state.bundle) {
        var pv = partnerFor();
        if (!pv) { say(hint, 'The set is not available in that size.'); return; }
        items.push({ id: pv.id, quantity: 1 });
      }
      say(hint, '');
      if (btn) btn.disabled = true;
      addToCart(items)
        .catch(function (err) { say(hint, err.message); })
        .then(function () { if (btn) btn.disabled = false; });
    }

    var add = qs('[data-add]', root);
    if (add) add.onclick = function () { doAdd(add); };
    var sadd = qs('[data-sticky-add]');
    if (sadd) sadd.onclick = function () { doAdd(sadd); };

    /* size guide */
    var guide = qs('[data-sizeguide]');
    qsa('[data-sg-open]').forEach(function (b) {
      b.onclick = function () { if (guide && guide.showModal) guide.showModal(); };
    });
    if (guide) {
      qsa('[data-sg-close]', guide).forEach(function (b) { b.onclick = function () { guide.close(); }; });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
    }

    /* sticky buy bar once the main button has scrolled away */
    var bar = qs('[data-sticky]');
    if (bar && add) {
      var io = new IntersectionObserver(function (entries) {
        bar.classList.toggle('on', !entries[0].isIntersecting);
      }, { rootMargin: '-10px 0px 0px 0px' });
      io.observe(add);
    }

    reframe();
    paint();
  }

  /* ---------------- the Legacy Set ---------------- */
  /* Two colours and a size, added as two lines in one request. The ten dollars
     comes off through the automatic discount, so nothing is priced here. */
  function legacySet() {
    var box = qs('[data-setcfg]');
    if (!box) return;
    var raw = qs('[data-sc-data]', box);
    if (!raw) return;
    var cat = JSON.parse(raw.textContent);
    if (!cat.tee.length || !cat.shorts.length) { box.hidden = true; return; }

    var state = { tee: null, shorts: null, size: null };
    var pick = function (list, color, size) {
      return list.filter(function (v) { return same(v.color, color) && v.size === size; })[0];
    };
    var anyIn = function (list, color) {
      return list.filter(function (v) { return same(v.color, color) && v.available; }).length > 0;
    };
    var sizeOK = function (s) {
      var a = pick(cat.tee, state.tee, s), b = pick(cat.shorts, state.shorts, s);
      return !!(a && a.available && b && b.available);
    };

    /* Open on the pairing that leaves the most sizes buyable, and prefer the
       matching colourway when two pairings tie. Taking the first colour in the
       list instead opened on grey on grey, where only L was left. */
    var uniq = function (list) {
      var seen = [], out = [];
      list.forEach(function (v) {
        if (seen.indexOf(norm(v.color)) === -1) { seen.push(norm(v.color)); out.push(v.color); }
      });
      return out;
    };
    var score = function (tc, sc) {
      return cat.sizes.filter(function (s) {
        var a = pick(cat.tee, tc, s), b = pick(cat.shorts, sc, s);
        return a && a.available && b && b.available;
      }).length;
    };
    var teeCols = uniq(cat.tee), shoCols = uniq(cat.shorts);
    var best = { t: teeCols[0], s: shoCols[0], n: -1 };
    teeCols.forEach(function (tc) {
      shoCols.forEach(function (sc) {
        var n = score(tc, sc);
        if (n > best.n || (n === best.n && same(tc, sc) && !same(best.t, best.s))) {
          best = { t: tc, s: sc, n: n };
        }
      });
    });
    state.tee = best.t;
    state.shorts = best.s;

    /* The stack images follow the swatches. Without this the shopper picked
       cream and kept looking at a black set. */
    /* The stack sits in the sibling column, not inside the configurator, so
       these lookups have to run against the whole section. */
    var scope = box.closest('.set') || document;
    var imgMap = {};
    var imgRaw = qs('[data-sc-images]', scope);
    if (imgRaw) { try { imgMap = JSON.parse(imgRaw.textContent); } catch (e) { imgMap = {}; } }
    function dressStack() {
      ['tee', 'shorts'].forEach(function (which) {
        var im = qs('[data-sc-img="' + which + '"]', scope);
        var src = (imgMap[which] || {})[state[which]];
        if (im && src && im.getAttribute('src') !== src) im.src = src;
      });
    }

    function paint() {
      dressStack();
      [['tee', cat.tee], ['shorts', cat.shorts]].forEach(function (pair) {
        var which = pair[0], list = pair[1];
        qsa('[data-sc-color="' + which + '"]', box).forEach(function (b) {
          var can = anyIn(list, b.dataset.v);
          b.disabled = !can;
          b.classList.toggle('gone', !can);
          b.classList.toggle('on', same(b.dataset.v, state[which]));
        });
        var n = qs('[data-sc-name="' + which + '"]', box);
        if (n) n.textContent = state[which] || '';
      });

      qsa('[data-sc-size]', box).forEach(function (b) {
        var can = sizeOK(b.dataset.scSize);
        b.disabled = !can;
        b.classList.toggle('gone', !can);
        b.classList.toggle('on', state.size === b.dataset.scSize);
      });
      if (state.size && !sizeOK(state.size)) state.size = null;

      var live = cat.sizes.filter(sizeOK);
      say(qs('[data-sc-hint]', box), live.length ? '' : 'This pairing is sold out. Try another colour.');
    }

    qsa('[data-sc-color]', box).forEach(function (b) {
      b.onclick = function () {
        if (b.disabled) return;
        state[b.dataset.scColor] = b.dataset.v;
        paint();
      };
    });
    qsa('[data-sc-size]', box).forEach(function (b) {
      b.onclick = function () {
        if (b.disabled) return;
        state.size = b.dataset.scSize;
        paint();
      };
    });

    var go = qs('[data-sc-add]', box), hint = qs('[data-sc-hint]', box);
    if (go) go.onclick = function () {
      if (!state.size) { say(hint, 'Pick a size to continue'); return; }
      var a = pick(cat.tee, state.tee, state.size), b = pick(cat.shorts, state.shorts, state.size);
      if (!a || !b || !a.available || !b.available) { say(hint, 'That combination is sold out.'); return; }
      say(hint, '');
      go.disabled = true;
      addToCart([{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }])
        .catch(function (err) { say(hint, err.message); })
        .then(function () { go.disabled = false; });
    };

    paint();
  }

  /* ---------------- bag ---------------- */
  function openBag() {
    var d = qs('[data-drawer]'), s = qs('[data-scrim]');
    if (d) d.classList.add('on');
    if (s) s.classList.add('on');
  }
  function closeBag() {
    var d = qs('[data-drawer]'), s = qs('[data-scrim]');
    if (d) d.classList.remove('on');
    if (s) s.classList.remove('on');
  }

  /* Routes come from Liquid by way of the drawer, because window.Shopify.routes
     carries nothing but root. */
  function drawerData(key, fallback) {
    var d = qs('[data-drawer]');
    return (d && d.dataset[key]) || fallback;
  }
  var cartUrl = function () { return drawerData('cartUrl', '/cart'); };
  var shopUrl = function () { return drawerData('shopUrl', '/collections/all'); };

  function refresh() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paintBag);
  }

  function paintBag(cart) {
    qsa('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.toggle('on', cart.item_count > 0);
    });
    var ct = qs('[data-ct]');
    if (ct) ct.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    var body = qs('[data-body]'), foot = qs('[data-foot]'), meter = qs('[data-meter]');
    if (!body) return;

    if (meter) {
      var threshold = parseInt(meter.dataset.threshold || '0', 10);
      if (threshold > 0 && cart.item_count) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        var done = cart.total_price >= threshold;
        meter.className = 'ship' + (done ? ' done' : '');
        meter.innerHTML = '<div class="mono">' +
          (done ? 'Free shipping unlocked'
                : money(threshold - cart.total_price) + ' away from free shipping') +
          '</div><div class="ship__bar"><i style="width:' + pct + '%"></i></div>';
      }
    }

    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><p class="h4" style="margin-bottom:8px">Your cart is empty</p>' +
        '<a class="btn" href="' + shopUrl() + '">Shop the drop</a></div>';
      if (foot) foot.innerHTML = '';
      if (meter) meter.style.display = 'none';
      return;
    }
    if (meter) meter.style.display = '';

    body.innerHTML = cart.items.map(function (l, i) {
      return '<div class="line">' +
        '<a class="line__img" href="' + l.url + '">' +
          (l.image ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '') +
        '</a>' +
        '<div><div class="line__top">' +
          '<a href="' + l.url + '"><span class="pcard__name">' + l.product_title + '</span></a>' +
          '<span class="price">' + money(l.final_line_price) + '</span></div>' +
        '<div class="line__meta mono-sm">' + (l.variant_title || '') + '</div>' +
        '<div class="line__ctl"><div class="qty">' +
          '<button data-ln="' + (i + 1) + '" data-d="-1" aria-label="Reduce quantity">&minus;</button>' +
          '<span>' + l.quantity + '</span>' +
          '<button data-ln="' + (i + 1) + '" data-d="1" aria-label="Increase quantity">+</button>' +
        '</div><button class="rm mono-sm" data-ln="' + (i + 1) + '" data-d="0">Remove</button></div>' +
      '</div></div>';
    }).join('');

    qsa('[data-ln]', body).forEach(function (b) {
      b.onclick = function () {
        var line = parseInt(b.dataset.ln, 10);
        var delta = parseInt(b.dataset.d, 10);
        var item = cart.items[line - 1];
        var q = delta === 0 ? 0 : item.quantity + delta;
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: q })
        }).then(refresh);
      };
    });

    if (foot) {
      foot.innerHTML =
        (cart.total_discount > 0
          ? '<div class="trow"><span>Discount</span><span class="ok">&minus;' + money(cart.total_discount) + '</span></div>'
          : '') +
        '<div class="trow big"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
        /* Checkout posts to the cart the way the cart page does, rather than
           linking at a guessed /checkout path. */
        '<form action="' + cartUrl() + '" method="post">' +
          '<button type="submit" name="checkout" class="btn btn--full btn--lg" style="margin-top:14px">Checkout</button>' +
        '</form>' +
        '<a class="mono-sm drawer__cart" href="' + cartUrl() + '">View cart</a>';
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openBag(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-scrim]')) closeBag();
    var q = e.target.closest('.faq__q');
    if (q) {
      var item = q.closest('.faq__i');
      var a = qs('.faq__a', item);
      var open = item.classList.toggle('on');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (a) a.style.height = open ? a.firstElementChild.offsetHeight + 'px' : '0px';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBag(); });

  /* ---------------- welcome popup ---------------- */
  /* Three steps: what they came for, their email, the code. The email goes to
     Shopify's own customer endpoint so the signup lands in Customers tagged,
     ready for a flow to pick up. Nothing is revealed until Shopify confirms
     the write — promising a code we failed to record would strand the shopper
     with an offer and us with no address to send it to. */
  function welcomePopup() {
    var root = qs('[data-wpop]');
    if (!root) return;

    var key = root.dataset.key || 'revon-welcome';
    var store = {
      get: function () { try { return localStorage.getItem(key); } catch (e) { return null; } },
      set: function (v) { try { localStorage.setItem(key, v); } catch (e) {} }
    };
    var seen = store.get();
    if ((seen === 'joined' || seen === 'dismissed') && location.search.indexOf('customer_posted=true') === -1) return;

    var box = qs('[data-wpop-box]', root);
    var choice = { key: 'all', url: root.querySelector('[data-wpop-shop]').getAttribute('href') };
    var lastFocus = null;

    function step(n) {
      qsa('[data-wpop-step]', root).forEach(function (el) {
        var on = el.dataset.wpopStep === String(n);
        el.classList.toggle('on', on);
        el.hidden = !on;
      });
      var focusable = qs('input, button, a', qs('[data-wpop-step="' + n + '"]', root));
      if (focusable) focusable.focus();
    }

    /* Shopify's cookie banner is itself a fixed overlay. Opening on top of it
       stacks two consent-shaped things on one screen and buries the offer, so
       wait for the banner to go before asking for an email. */
    function consentShowing() {
      var b = qs('.shopify-pc__banner');
      return !!(b && b.offsetParent !== null);
    }

    function open() {
      if (store.get()) return;
      if (consentShowing()) { setTimeout(open, 1200); return; }
      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('on'); });
      document.body.classList.add('is-locked');
      step(1);
    }

    function close(reason) {
      root.classList.remove('on');
      document.body.classList.remove('is-locked');
      setTimeout(function () { root.hidden = true; }, 450);
      if (reason) store.set(reason);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    qsa('[data-wpop-dismiss]', root).forEach(function (b) {
      b.onclick = function () { close('dismissed'); };
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close('dismissed');
      /* keep tab inside the dialog while it is up */
      if (e.key === 'Tab' && !root.hidden) {
        var f = qsa('button, a[href], input', box).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    qsa('[data-wpop-choice]', root).forEach(function (b) {
      b.onclick = function () {
        choice = { key: b.dataset.wpopChoice, url: b.dataset.url, label: (qs('.wpop__pick-t', b) || {}).textContent };
        var echo = qs('[data-wpop-echo]', root);
        if (echo) echo.textContent = choice.label ? 'Good pick · ' + choice.label : 'Ten percent off';
        /* carry the interest as a tag — a customer form rejects contact[note],
           and a tag is what an email flow can actually segment on */
        var tags = qs('[data-wpop-tags]', root);
        if (tags && !tags.dataset.base) tags.dataset.base = tags.value;
        if (tags) tags.value = tags.dataset.base + ',wants-' + choice.key;
        step(2);
      };
    });

    /* The signup is a NATIVE form post, not fetch. This store has Shopify's
       CAPTCHA on customer forms, and the token is injected by Shopify's own
       script when the real submit event fires — an AJAX post has no token and
       comes back 400 "Missing CAPTCHA token" every time. So the page really
       does navigate, and we pick the shopper back up on the way in. */
    var pendingKey = key + '-pending';
    var form = qs('.wpop__form', root);
    if (form) {
      form.addEventListener('submit', function () {
        var email = qs('input[type="email"]', form);
        if (!email || !email.value || email.value.indexOf('@') === -1) return;
        try {
          localStorage.setItem(pendingKey, JSON.stringify({ url: choice.url, label: choice.label || '' }));
        } catch (e) {}
        var btn = qs('[data-wpop-submit]', form);
        if (btn) {
          var label = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'One second…';
          /* If the post never lands — a bot check steps in, the network drops,
             the page simply does not navigate — the button would otherwise sit
             disabled reading "One second…" forever and the shopper could never
             try again. Give it back to them. */
          setTimeout(function () {
            if (!btn.disabled) return;
            btn.disabled = false;
            btn.textContent = label;
            say(qs('[data-wpop-error]', root), 'That did not go through. Check the address and try again.');
          }, 8000);
        }
      });
    }

    /* Coming back from Shopify with the signup accepted. */
    function resumeAfterSignup() {
      /* Shopify's own posted_successfully? marker is the primary signal; the
         query string is a fallback for when it redirects rather than
         re-rendering. */
      var ok = qs('[data-wpop-success]', root) || location.search.indexOf('customer_posted=true') !== -1;
      var failed = qs('[data-wpop-failed]', root);
      if (failed) {
        lastFocus = document.activeElement;
        root.hidden = false;
        requestAnimationFrame(function () { root.classList.add('on'); });
        document.body.classList.add('is-locked');
        step(2);
        say(qs('[data-wpop-error]', root), failed.textContent.trim());
        return true;
      }
      if (!ok) return false;
      var pending = null;
      try { pending = JSON.parse(localStorage.getItem(pendingKey) || 'null'); } catch (e) {}
      try { localStorage.removeItem(pendingKey); } catch (e) {}
      store.set('joined');

      var shop = qs('[data-wpop-shop]', root);
      if (shop && pending && pending.url) shop.setAttribute('href', pending.url);
      var code = root.dataset.code;
      if (code) fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code)).catch(function () {});

      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('on'); });
      document.body.classList.add('is-locked');
      step(3);

      /* drop the query string so a refresh does not replay the reveal */
      if (history.replaceState) {
        history.replaceState({}, '', location.pathname + location.hash);
      }
      return true;
    }

    var copy = qs('[data-wpop-copy]', root);
    if (copy) copy.onclick = function () {
      var text = (qs('[data-wpop-codetext]', copy) || {}).textContent || '';
      var done = function () {
        copy.classList.add('copied');
        var label = qs('.wpop__copy', copy);
        if (label) { label.textContent = 'Copied'; }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text.trim()).then(done).catch(done);
      } else { done(); }
    };

    if (resumeAfterSignup()) return;

    var delay = parseInt(root.dataset.delay, 10);
    setTimeout(open, (isNaN(delay) ? 6 : delay) * 1000);
  }

  function boot() { nav(); hero(); product(); legacySet(); welcomePopup(); refresh(); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
